import { Injectable, Type } from '@angular/core';
import {
  ApiResponse,
  BaseApiService,
} from '@kinet-open-network/client/core/api-client';
import {
  IDeliveryFlowItem,
  IMapBounds,
  IMapItem,
} from '@kinet-open-network/shared/data-access/model';
import { Delivery } from '../models/delivery.model';

@Injectable({
  providedIn: 'root',
})
export class DeliveriesService extends BaseApiService<Delivery> {
  override model: Type<Delivery> = Delivery;

  override get endpoint(): string {
    return '/deliveries';
  }

  /** Returns current flow-entity assignments for a delivery. */
  getFlows(deliveryId: string) {
    return this.http.get<ApiResponse<IDeliveryFlowItem[]>>(
      `/deliveries/${this.encodeId(deliveryId)}/flows`,
      {
        context: this.subjectContext({ defaultResponse: { data: [] } }),
      },
    );
  }

  /** Returns flow entities with GPS coordinates within the given bounds, not yet assigned to a delivery. */
  getMapItems(bounds: IMapBounds) {
    return this.http.get<ApiResponse<{ type: string; items: IMapItem[] }[]>>(
      '/deliveries/map-items',
      {
        params: {
          n: bounds.n,
          w: bounds.w,
          s: bounds.s,
          e: bounds.e,
          ...(bounds.zoom !== undefined ? { zoom: bounds.zoom } : {}),
        },
        context: this.subjectContext({ defaultResponse: { data: [] } }),
      },
    );
  }
}
